import { AppDispatch } from "../redux/store";

interface DeleteHandlerParams {
  dispatch: AppDispatch;
  deleteAction: (params: any) => any;
  refreshAction: (params: any) => any;
  page: number;
  selectedValue: string | null;
  onSuccess: () => void;
  onFinally?: () => void;
}

export const handleDeleteGeneric = async ({
  dispatch,
  deleteAction,
  refreshAction,
  page,
  selectedValue,
  onSuccess,
  onFinally,
}: DeleteHandlerParams) => {
  if (!selectedValue) return;

  try {
    await dispatch(deleteAction(selectedValue)).unwrap();
    await dispatch(refreshAction({ page })).unwrap();
    onSuccess();
  } catch (error) {
    console.error("Erro ao deletar:", error);
  } finally {
    onFinally?.();
  }
};